export default __webpack_public_path__ + "static/media/destination-without-image.239ef5b0.jpg";